import { createFileRoute } from "@tanstack/react-router";
import { ServicePage } from "@/components/sections/service-page";
import { pageData } from "@/lib/service-page-data";
const data = pageData["devops"];
export const Route = createFileRoute("/services/devops")({
  component: () => <ServicePage data={data} />,
  head: () => ({
    meta: [
      { title: `${data.title} Services — CoderLity` },
      { name: "description", content: data.sub },
      { property: "og:title", content: `${data.title} Services — CoderLity` },
      { property: "og:description", content: data.sub },
      { property: "og:url", content: "/services/devops" },
    ],
    links: [{ rel: "canonical", href: "https://coderlity.com/services/devops" }],
  }),
});
